import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LOGO_URL } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

/**
 * Signature on-load: counter 000 → 100, then the panel slides up.
 * Runs only once per session.
 */
export default function IntroLoader() {
    const [count, setCount] = useState(0);
    const [gone, setGone] = useState(false);

    useEffect(() => {
        const shown = sessionStorage.getItem("kliving_intro");
        if (shown) {
            setGone(true);
            return;
        }
        let n = 0;
        const step = () => {
            n += Math.max(1, Math.round(Math.random() * 4));
            if (n >= 100) {
                setCount(100);
                sessionStorage.setItem("kliving_intro", "1");
                setTimeout(() => setGone(true), 550);
                return;
            }
            setCount(n);
            setTimeout(step, 55);
        };
        step();
    }, []);

    return (
        <AnimatePresence>
            {!gone && (
                <motion.div
                    key="intro"
                    data-testid="intro-loader"
                    initial={{ y: 0 }}
                    exit={{ y: "-100%" }}
                    transition={{ duration: 1.1, ease: EASE }}
                    className="fixed inset-0 z-[100] bg-forest-950 text-ivory flex flex-col"
                >
                    <div className="flex-1 flex items-end justify-between px-6 md:px-10 pb-14 md:pb-16">
                        <div className="flex items-end">
                            <div className="h-24 md:h-28 w-auto flex items-center">
                                <img src={LOGO_URL} alt="KLiving" className="h-full w-auto object-contain logo-white" />
                            </div>
                        </div>
                        <div className="font-serif-display italic text-[8rem] md:text-[16rem] leading-[0.85] text-lime tabular-nums">
                            {String(count).padStart(3, "0")}
                        </div>
                    </div>
                    <div className="h-[3px] w-full bg-white/10">
                        <motion.div
                            className="h-full bg-lime"
                            initial={{ width: "0%" }}
                            animate={{ width: `${count}%` }}
                            transition={{ ease: "linear", duration: 0.1 }}
                        />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
